// src/layouts/TenantLayout.jsx
import React from 'react';
import { Box, AppBar, Toolbar, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';
import TenantSidebar from '../pages/tenant/TenantSidebar';
export default function TenantLayout() {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f9f9f9' }}>
      {/* Custom Sidebar */}
      <TenantSidebar />

      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1 }}>
        

        {/* Page Content */}
        <Box p={3}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}